import React, { FC } from 'react';

interface IPlusIcon {
  size?: 'small' | 'default';
  color?: string;
}

export const PlusIcon: FC<IPlusIcon> = (props) => {
  const { size = 'default', color = '#ffffff' } = props;

  return size === 'small' ? (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.713 8.49465H3.78703C3.655 8.49465 3.54166 8.38131 3.54166 8.24928C3.54166 8.11725 3.655 8.00391 3.78703 8.00391H13.713C13.845 8.00391 13.9583 8.11725 13.9583 8.24928C13.9583 8.38131 13.845 8.49465 13.713 8.49465Z"
        fill={color}
        stroke={color}
        strokeWidth="0.75"
      />
      <path
        d="M8.74998 13.8327C8.41084 13.8327 8.12961 13.5514 8.12961 13.2123V3.28639C8.12961 2.94725 8.41084 2.66602 8.74998 2.66602C9.08911 2.66602 9.37035 2.94725 9.37035 3.28639V13.2123C9.37035 13.5514 9.08911 13.8327 8.74998 13.8327Z"
        fill={color}
      />
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.8646 9.35847H3.69792C3.68171 9.35847 3.66228 9.35202 3.64455 9.33429C3.62682 9.31656 3.62037 9.29713 3.62037 9.28092C3.62037 9.26472 3.62682 9.24529 3.64455 9.22756C3.66228 9.20983 3.68171 9.20338 3.69792 9.20338H14.8646C14.8808 9.20338 14.9002 9.20983 14.9179 9.22756C14.9357 9.24529 14.9421 9.26471 14.9421 9.28092C14.9421 9.29713 14.9357 9.31656 14.9179 9.33429C14.9002 9.35202 14.8808 9.35847 14.8646 9.35847Z"
        fill={color}
        stroke={color}
        strokeWidth="1.24074"
      />
      <path
        d="M9.28124 14.9421C9.26504 14.9421 9.24561 14.9357 9.22788 14.9179C9.21015 14.9002 9.2037 14.8808 9.2037 14.8646V3.69792C9.2037 3.68171 9.21015 3.66228 9.22788 3.64455C9.24561 3.62682 9.26504 3.62037 9.28124 3.62037C9.29745 3.62037 9.31688 3.62682 9.33461 3.64455C9.35234 3.66228 9.35879 3.68171 9.35879 3.69792V14.8646C9.35879 14.8808 9.35234 14.9002 9.33461 14.9179C9.31688 14.9357 9.29745 14.9421 9.28124 14.9421Z"
        fill={color}
        stroke={color}
        strokeWidth="1.24074"
      />
    </svg>
  );
};
